"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberWithCommas = exports.getLastTwoDigit = void 0;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var getLastTwoDigit = function getLastTwoDigit(num) {
  var numString = num.toString();

  if (numString.length > 2) {
    numString = numString.substr(-2);
  }

  return numString;
};

exports.getLastTwoDigit = getLastTwoDigit;

var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

exports.numberWithCommas = numberWithCommas;